import { useEffect, useState } from 'react';

import { useRouter } from 'next/router';

import classNames from 'classnames';
import { Form, Formik } from 'formik';
import qs from 'query-string';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import * as Yup from 'yup';

import Button from 'src/app/components/Elements/Button';
import { Step } from 'src/app/components/Pages/GetStarted/StepLayout/Step';
import { useOnboardingZipCodePersistentData } from 'src/app/hooks/feature_data/useOnboardingZipCodePersistentData';
import { getStarted } from 'src/app/router/paths';
import { setCurrentOnboardingStep, setOnboardingFormValues } from 'src/app/state/actions/onBoardingFlow';

import { OnboardingZipCode } from '../../OnboardingZipCode';
import { STEP_NAME } from '../../StepLayout/consts';
import { ButtonContainer, StyledSubtitle } from '../../styles';
import styles from '../../styles.module.scss';

export const IneligibleStep = () => {
  const dispatch = useDispatch();
  const { push } = useHistory();
  const router = useRouter();
  const location = useLocation();
  const { zipCode } = qs.parse(location.search);
  const { onboardingZipCodePersistentData } = useOnboardingZipCodePersistentData();

  const sanitizedZipCode = zipCode?.toString().replace(/\D/g, '');
  const [titleZipCode, setTitleZipCode] = useState(onboardingZipCodePersistentData?.zipCode || zipCode || 'your area');

  useEffect(() => {
    dispatch(setCurrentOnboardingStep(STEP_NAME.INELIGIBLE_STEP));
  }, []);

  return (
    <Step
      title={`We’re not in ${titleZipCode} just yet`}
      text={
        <StyledSubtitle maxWidth={55}>
          Try another zip code (we can also deliver to your office), or enter your email to get early access to Capsule
          when we're in your neighborhood.
        </StyledSubtitle>
      }
      handlePrev={
        () => router.replace('/') // Using NextJs router because `/` is a server side route.
      }
    >
      <Formik
        initialValues={{ zipCode: sanitizedZipCode || '' }}
        validationSchema={Yup.object().shape({
          zipCode: Yup.string().required('').min(5, '').label('Zip code'),
        })}
        onSubmit={(values, { setSubmitting, setFieldError }) => {
          dispatch(
            setOnboardingFormValues({
              zipCode: onboardingZipCodePersistentData?.zipCode || '',
            })
          );
          if (onboardingZipCodePersistentData?.isDeliverable) {
            push(`${getStarted.toPath()}?step=contact`);
          } else {
            setTitleZipCode(values.zipCode);
            setFieldError('zipCode', ' ');
          }
          setSubmitting(false);
        }}
      >
        {({ values, isSubmitting }) => (
          <Form>
            <OnboardingZipCode
              name="zipCode"
              label="Delivery Zip Code"
              labelOnFocus="Delivery Zip Code"
              wrapperClassName={styles.fixedWidth}
            />
            <ButtonContainer>
              <Button
                className={classNames(styles.fixedWidth, styles.noMargins, styles.borderRadius)}
                size="medium"
                disabled={isSubmitting || values.zipCode.length < 5 || !onboardingZipCodePersistentData}
                type="submit"
                style={'capsuleBlue50'}
              >
                Continue
              </Button>
            </ButtonContainer>
            <Button
              style="tertiary"
              className="pl-0"
              size="small"
              onClick={() => push(`${getStarted.toPath()}?step=join_waitlist`)}
              type="button"
            >
              Get Early Access
            </Button>
          </Form>
        )}
      </Formik>
    </Step>
  );
};
